module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('h3', [_vm._v("借用信息")]), _vm._v(" "), _c('el-form', {
    ref: "formLabelAlign",
    attrs: {
      "label-position": "left",
      "rules": _vm.rules,
      "label-width": "80px",
      "model": _vm.formLabelAlign
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "借用人",
      "prop": "usedUserName"
    }
  }, [_c('el-autocomplete', {
    staticClass: "inline-input",
    attrs: {
      "prop": "usedUserName",
      "fetch-suggestions": _vm.querySearch,
      "placeholder": "请输入内容"
    },
    on: {
      "select": _vm.handleSelect
    },
    model: {
      value: (_vm.formLabelAlign.usedUserName),
      callback: function($$v) {
        _vm.$set(_vm.formLabelAlign, "usedUserName", $$v)
      },
      expression: "formLabelAlign.usedUserName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "借用时间",
      "required": ""
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "format": "yyyy 年 MM 月 dd 日",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.usedDate),
      callback: function($$v) {
        _vm.usedDate = $$v
      },
      expression: "usedDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": "remark"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.formLabelAlign.remark),
      callback: function($$v) {
        _vm.$set(_vm.formLabelAlign, "remark", $$v)
      },
      expression: "formLabelAlign.remark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "文件上传"
    }
  }, [_c('el-upload', {
    attrs: {
      "action": "/api/upload/singlefile/seal",
      "on-preview": _vm.handlePreview,
      "file-list": _vm.fileList,
      "headers": _vm.headers,
      "on-success": _vm.onSuccess,
      "on-remove": _vm.handleRemove
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "trigger",
      "size": "small",
      "type": "primary"
    },
    slot: "trigger"
  }, [_vm._v("附件上传")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("如果是多个附件,请打包上传")])], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('formLabelAlign')
      }
    }
  }, [_vm._v("借用")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.resetForm('formLabelAlign')
      }
    }
  }, [_vm._v("重置")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34af6b6a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/chapterManagement/increase.vue
// module id = 1010
// module chunks = 2